import { useEffect, useState } from 'react';

export default function Hero() {
  const [isLoaded, setIsLoaded] = useState(false);

  useEffect(() => {
    setIsLoaded(true);
  }, []);

  return (
    <section className="relative min-h-screen flex items-center justify-center overflow-hidden bg-gray-900">
      {/* Background Image with Overlay */}
      <div className="absolute inset-0">
        <img
          src="https://public.readdy.ai/ai/img_res/ee78b155e587be7d99ae83488a1a0f44.jpg"
          alt="Professional Parking Lot Services"
          className="w-full h-full object-cover object-top"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-black/40 via-black/30 to-black/40"></div>
      </div>

      {/* Content */}
      <div className="relative z-10 w-full px-6 lg:px-8 py-32 lg:py-0">
        <div className="max-w-[1180px] mx-auto">
          <div className="flex flex-col lg:flex-row items-center lg:items-center gap-6 lg:gap-8">
            {/* Logo */}
            <div className={`flex-shrink-0 ${isLoaded ? 'lg:animate-fade-up lg:delay-60' : 'lg:opacity-0'}`}>
              <img
                src="https://static.readdy.ai/image/77d46a0f4a774521f072e7d3cc1d9be9/c5934c9d8b7147ad65626fd90d4dfe1a.png"
                alt="Sooner Blacktop"
                className="w-32 h-32 lg:w-52 lg:h-52"
              />
            </div>

            {/* Text Content */}
            <div className="flex-1 text-center lg:text-left">
              <h1 className={`text-5xl md:text-6xl lg:text-6xl font-bold text-white mb-4 lg:mb-5 leading-tight ${isLoaded ? 'lg:animate-fade-up lg:delay-110' : 'lg:opacity-0'}`} style={{ fontFamily: 'Oswald, sans-serif', animationDuration: '540ms' }}>
                Parking Lot Striping & <br />
                Sealcoating in Oklahoma City
              </h1>
              <p className={`text-xl md:text-2xl text-gray-100 mb-8 lg:mb-6 max-w-[720px] mx-auto lg:mx-0 leading-[1.45] ${isLoaded ? 'lg:animate-fade-up lg:delay-180' : 'lg:opacity-0'}`}>
                Professional pavement maintenance for commercial properties across the OKC metro
              </p>
              <div className={`flex flex-col sm:flex-row gap-4 justify-center lg:justify-start ${isLoaded ? 'lg:animate-fade-up lg:delay-240' : 'lg:opacity-0'}`}>
                <a
                  href="#quote"
                  className="inline-flex items-center justify-center px-8 py-4 bg-yellow-400 text-black font-bold rounded-lg hover:bg-yellow-500 transition-all whitespace-nowrap cursor-pointer lg:hover-lift"
                >
                  <i className="ri-file-list-3-line mr-2 text-xl"></i>
                  Get Free Quote
                </a>
                <a
                  href="tel:405-367-6799"
                  className="inline-flex items-center justify-center px-8 py-4 bg-white/10 backdrop-blur-sm text-white font-bold rounded-lg hover:bg-white/20 transition-all whitespace-nowrap cursor-pointer border-2 border-white/30 lg:hover-lift"
                  style={{ animationDelay: '320ms' }}
                >
                  <i className="ri-phone-line mr-2 text-xl"></i>
                  (405) 367-6799
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Scroll Indicator */}
      <div className="absolute bottom-8 left-1/2 -translate-x-1/2 animate-bounce">
        <i className="ri-arrow-down-line text-white text-3xl"></i>
      </div>
    </section>
  );
}
